import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { searchDepartmentsApi } from "../../API/API";

function* searchDepartmentsSaga(params) {
  try {
    const response = yield call(() => searchDepartmentsApi(params));
    yield put({ type: types.SEARCH_DEPARTMENTS_SUCCESS, payload: response.data?.data?.departments || [] });
  } catch (error) {
    yield put({ type: types.SEARCH_DEPARTMENTS_FAILURE, error });
  }
}

export function* watchSearchDepartmentsSaga() {
  yield takeLatest(types.SEARCH_DEPARTMENTS_INIT, searchDepartmentsSaga);
}
